export class ValidationError {

  constructor(
    public name: string,
    public details: any = {}
  ) { }

}
